module.exports = __webpack_public_path__ + "img/merchant-banner.79e61ff9.png";